import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import ButtonBack from "../../../components/button/ButtonBack";

const OTP = ({ otp, handleChange, handleKeyDown, handlePaste, error, back }) => {

  const { language } = useContext(UtilContext); // Usa el contexto de Auth

  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-full md:w-3/4 flex justify-evenly flex-col items-center md:items-start px-6 md:px-0"
    >
      <div className="w-full flex flex-col items-center md:items-start">
        <p
          className="text-2xl md:text-[32px] text-white text-center md:text-left"
          style={{ fontFamily: "brico", marginBottom: 18 }}
        >
          {GLOBAL_LANGUAGE[language].two_factor.title}
        </p>
        <p
          className="text-sm md:text-[14px] text-white text-center md:text-left"
          style={{ fontFamily: "sans" }}
        >
          {GLOBAL_LANGUAGE[language].two_factor.description}
        </p>

        <div className="flex justify-center md:justify-start items-center w-full mt-5">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              className="w-[45px] h-[45px] md:w-[62px] md:h-[64px] text-xl md:text-[32px] text-center bg-[#26262D] rounded-[5px] border border-[#5E5E63] mr-2 md:mr-4 focus:border-[#8E8E93] focus:outline-none"
              maxLength={1}
            />
          ))}
        </div>
      </div>

      <p className="text-[#e4847f] text-sm md:text-base text-center md:text-left mt-4 w-full md:w-3/4">{error}</p>
      <div className="w-full flex justify-center md:justify-start mt-6">
        <ButtonBack
          label="Volver"
          onClick={() => back(1)}
          paddingY={2}
          className="w-full md:w-fit"
        />
      </div>
    </div>
  );
};

export default OTP;

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo oscuro semi-transparente
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  qrContainer: {
    display: "flex",
    marginTop: 20,
    alignItems: "center",
  },
  input: {
    width: "62px",
    height: "64px",
    fontSize: 32,
    marginRight: "16px",
    textAlign: "center",
    borderRadius: "5px",
    color: ColorsMain.texttMain,

    background: ColorsMain.bgMain,
  },
};
